import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  allowedImageFormats,
  isLargeScreen,
  uploadedFileCheck,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { companyTableDetails } from '../../../pages/pages/tableDetails';
import { AddEditSiteComponent } from '../../../shared/components/add-edit-site/add-edit-site.component';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from '../../../shared/components/contact/contact.component';
import { EventSchedulerComponent } from '../../../shared/components/event-scheduler/event-scheduler.component';
import { MediaPreviewComponent } from '../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';

@Component({
  selector: 'gtapp-view-site',
  standalone: false,
  templateUrl: './view-site.component.html',
  styleUrl: './view-site.component.scss',
})
export class ViewSiteComponent implements OnInit, OnDestroy {
  @Input() siteId: any = '';

  siteDetailData: any;

  selectedSiteFiles: any = [];
  siteHistory: any = [];

  dialogRef: any;

  fileUploadError: any;
  fileDescription: any;
  uploadFile: any;

  userEventDetailsTableView = companyTableDetails?.desktopTable;
  selectedEvent: any;
  largeView: Boolean = isLargeScreen;

  constructor(
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
  ) {}
  ngOnDestroy(): void {
    this.appService.removeToolTips();
  }

  ngOnInit(): void {
    this.siteId = this.siteId || this.route.snapshot.paramMap.get('sKey');

    this.getSiteDetailById();
  }
  scrollToReportSection(containerId: any) {
    setTimeout(() => {
      const idElement = document.querySelector(containerId);

      if (idElement) {
        idElement?.scrollIntoView();
      }
    }, 200);
  }
  getSiteHistoryData() {
    this.clientService
      .getSiteDetailsById(this.siteId, { get_history: 1 })
      .subscribe((response: any) => {
        this.siteHistory = response?.data || [];
      });
  }

  getSiteDetailById() {
    this.spinnerService.show();
    this.clientService
      .getSiteDetailsById(this.siteId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        }
        this.spinnerService.hide();
      });
  }
  formatSiteData(response: any) {
    this.appService.initializeBootstrapTooltips();

    this.siteDetailData = response?.data;

    this.selectedSiteFiles = this.siteDetailData?.site_files || [];

    // if (this.largeView) this.getSiteHistoryData();
  }

  onTableRowClick(event: any) {
    this.selectedEvent = event;
  }

  editSite(editSiteName: boolean = false) {
    const addSiteDialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: this.siteDetailData,
        editSite: true,
        editSiteName: editSiteName,
      },
    });
    addSiteDialogRef.afterClosed().subscribe((value) => {
      if (value !== 'close') {
        if (value?.id) {
          this.formatSiteData({ data: value });
        } else {
          this.getSiteDetailById();
        }
      }
    });
  }

  openSiteContactTemplate(data: any, siteData: any, contactType: any) {
    this.dialogRef = this.dialogService.open(ContactComponent, {
      data: {
        contactData: data,

        siteData: siteData,
        contactType: contactType,
      },
    });
    this.dialogRef.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse !== false) {
        this.getSiteDetailById();
      }
    });
  }

  async openInformationTemplate(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          newValue: this.siteDetailData?.information,
          oldValue: this.siteDetailData?.information,
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());

    if (res) {
      this.spinnerService.show('Updating Site Information');
      this.clientService
        .updateSite(
          this.siteDetailData?.id,
          {
            information: res?.newValue,
          },
          { update_information: 1 },
        )
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatSiteData(response);
            this.spinnerService.hide();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            this.spinnerService.hide();
          }
        });
    }
  }

  openFileUploadTemplate(template: any) {
    this.fileUploadError = null;
    this.fileDescription = null;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }

  async handleFileInput(event: any) {
    let file = event?.target?.files.item(0);

    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    this.fileUploadError = await uploadedFileCheck(
      fileExtension,
      fileSize,
      1024 * 1024 * 8,
      ['pdf', ...allowedImageFormats],
    );
    if (!this.fileUploadError) {
      this.uploadFile = event?.target?.files.item(0);
    }
  }

  onUploadFile() {
    if (this.uploadFile) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', this.uploadFile);
      fileData.append('upload_files', '1');
      fileData.append('description', this.fileDescription);

      this.appService
        .formDataApi(`site/${this.siteDetailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response?.status == 'success') {
            this.formatSiteData(response);
            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
          } else {
            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
            });
          }
        });
    }
  }
  onOpenFile(file: any) {
    if (file?.extension === '.pdf') {
      this.downloadFile(file);
    } else {
      this.dialogRef = this.dialogService.open(
        MediaPreviewComponent,
        {
          data: { mediaSrc: file?.file_url },
        },
        this.viewContainerRef,
      );
    }
  }
  openSchedulerTemplate(schedule?: any) {
    this.dialogRef = this.dialogService.open(EventSchedulerComponent, {
      data: { siteData: this.siteDetailData, scheduleData: schedule },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.formatSiteData(value);
      }
    });
  }

  downloadFile(file: any) {
    const a = document.createElement('a');
    a.href = file?.file_url;
    a.download = `${file?.name}${file?.extension}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  deleteSiteFile(file: any) {
    this.clientService
      .updateSite(this.siteDetailData?.id, {
        file_id: file?.id,
        delete_file: 1,
      })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  deleteFile(file: any) {
    let dialogMsg = `Permanently delete file: ${file.description}`;
    this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete File`,
        message: dialogMsg,
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.deleteSiteFile(file);
      }
    });
  }

  shiftFocus(elementId: string, time?: number) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, time);
  }

  selectFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  deleteSite(site: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete Site`,
        message: `Checkpoints belonging to deleted sites will no longer be available.`,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .enableDisableSiteById(site?.id)
          .then((response: any) => {
            if (response?.status == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this.router.navigate(['/sites']);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }
  onFocus(inputType: string, index: number) {
    const keyInput = document.getElementById(`Key${index}`);
    const descriptionInput = document.getElementById(`Description${index}`);

    if (inputType === 'Key') {
      keyInput?.classList.add('focused');
      descriptionInput?.classList.remove('focused');
    } else {
      descriptionInput?.classList.add('focused');
      keyInput?.classList.remove('focused');
    }
  }

  onBlur(inputType: string, index: number) {
    const keyInput = document.getElementById(`Key${index}`);
    const descriptionInput = document.getElementById(`Description${index}`);

    keyInput?.classList.remove('focused');
    descriptionInput?.classList.remove('focused');
  }
  reportSendApproval() {
    this.spinnerService.show();
    this.clientService
      .updateSite(this.siteDetailData?.id, {}, { send_report_approval: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  openCamPopup() {
    var button: any = document.getElementById('siteLogoInput');
    button.click();
  }

  async handleSiteLogoInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await uploadedFileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
  onFileSubmit(file: any) {
    if (file) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', file);
      fileData.append('upload_logo', '1');

      this.appService
        .formDataApi(`site/${this.siteDetailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatSiteData(response);
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
    }
  }
  removeSiteLogo() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Remove Logo`,
        message: '',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.clientService
          .updateSite(this.siteDetailData?.id, {
            remove_logo: 1,
          })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.formatSiteData(response);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }
  updateProrityMessage(message: string) {
    this.spinnerService.show('Updating Changes');
    this.clientService
      .updateSite(
        this.siteDetailData?.id,
        {
          priority_notes: message,
        },
        { update_priority_notes: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  async openTemplate(template: any, event?: any) {
    if (event) {
      const checked = event.target.checked;
      if (!checked) {
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: `Priority Alarm Response Site`,
            message: 'Remove message?',
          },
        });
        const res = await firstValueFrom(dialogRef.afterClosed());
        if (!res) {
          if (event)
            event.target.checked =
              !!this.siteDetailData?.additional_info?.priority_info?.notes;
          return;
        }
        this.updateProrityMessage('');
        return;
      }
    }

    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          newValue:
            this.siteDetailData?.additional_info?.priority_info?.notes ||
            this.siteDetailData?.additional_info?.priority_info?.backup_notes,
          oldValue: this.siteDetailData?.additional_info?.priority_info?.notes,
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (!res) {
      if (event)
        event.target.checked =
          !!this.siteDetailData?.additional_info?.priority_info?.notes;
      return;
    }
    this.updateProrityMessage(res?.newValue);
  }
}
